export const GET_WS_CLIENTS = 'GET_WS_CLIENTS'
export const SET_WS_CLIENTS = 'SET_WS_CLIENTS'
export const SAVE_WS_CLIENT = "SAVE_WS_CLIENT"
export const DELETE_WS_CLIENT = "DELETE_WS_CLIENT"
export const GET_PRIVILEGE = 'GET_PRIVILEGE'
export const SET_PRIVILEGE = 'SET_PRIVILEGE'
export const SAVE_PRIVILEGE = 'SAVE_PRIVILEGE'


export const getPrivilege = () => ({
    type: GET_PRIVILEGE
})
export const setPrivilege = (privilege: any) => ({
    type: SET_PRIVILEGE,
    privilege
})

export const getWSClients = () => ({
    type: GET_WS_CLIENTS
})

export const saveWSClient = () => ({
    type: SAVE_WS_CLIENT
})

export const deleteWSClient = () => ({
    type: DELETE_WS_CLIENT
})

export const setWSClients = (clients: any) => ({
    type: SET_WS_CLIENTS,
    clients
})


const initialState = {

}

export const authorizationReducer = (state = initialState, action: any) => {

    const { clients } = action;
    const { privilege } = action;

    switch (action.type) {
        case SET_WS_CLIENTS:
            return { ...state, clients: clients };
        case SET_PRIVILEGE:
            //Sort privileges before setting state.
            const sortPriv = (key: any) => (a: any, b: any) => a[key] > b[key] ? 1: -1;
            //Sort on resource as key
            const sortedPriv = privilege.slice().sort(sortPriv('resource'));
            return { ...state, privilege: sortedPriv };
        default:
            return state
    }
}